import React from 'react';
import { Spin } from 'antd';
import styles from './styles/Map.module.css';

const Map = ({ mapRef, loading, loadingTip }) => {
  return (
    <div className={styles.mapContainer}>
      <div ref={mapRef} className={styles.map} />
      {loading && (
        <div className={styles.loadingOverlay}>
          <Spin tip={loadingTip} />
        </div>
      )}
    </div>
  );
};

export default Map; 